export default "__VITE_ASSET__CGM5u2_E__"